import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { FacebookIcon, InstagramIcon, LinkedInIcon, TwitterIcon } from '@/features/shared/Icons';

const resolveSocialIcon = (social?: SocialChannelType): React.FC<SvgIconProps> | undefined => {
  if (social === 'facebook' || social === '"facebook"') {
    return FacebookIcon;
  }
  if (social === '"instagram"' || social === 'instagram') {
    return InstagramIcon;
  }
  if (social === '"twitter"' || social === 'twitter') {
    return TwitterIcon;
  }
  if (social === '"linkedIn"' || social === 'linkedIn') {
    return LinkedInIcon;
  }
  return undefined;
};

export default resolveSocialIcon;
